export const applyPortraitMode = async (canvas, ctx, setMessage, language) => {
  // 각 단계별 진행 상황 업데이트
  setMessage(language === 'KR' ? '인물 모드 적용 중 (1/3) - 피부톤 조정...' : 'Applying Portrait Mode (1/3) - Adjusting skin tones...');
  await new Promise(resolve => setTimeout(resolve, 500)); // 진행 효과를 위한 딜레이
  
  // 인물 모드 효과 적용
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 1. 배경 블러 효과 (실제로는 간단한 시뮬레이션)
  for (let i = 0; i < data.length; i += 4) {
    // 피부톤 감지 및 조정
    const isLikelySkin = (data[i] > 60 && data[i + 1] > 40 && data[i + 2] > 20 && 
        data[i] > data[i + 2] && data[i + 1] > data[i + 2]);
    
    if (isLikelySkin) {
      // 피부톤을 더 자연스럽게
      data[i] = Math.min(255, data[i] * 1.05); // 빨간색 약간 강화
      data[i + 1] = Math.min(255, data[i + 1] * 1.02); // 녹색 약간 강화
    }
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 선명도 조정
  setMessage(language === 'KR' ? '인물 모드 적용 중 (2/3) - 선명도 조정...' : 'Applying Portrait Mode (2/3) - Adjusting sharpness...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // 샤프닝 필터 적용 (언샵 마스크 간소화 버전)
  const sharpenImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const sharpenData = sharpenImageData.data;
  
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 3x3 샤프닝 필터
  for (let y = 1; y < canvas.height - 1; y++) {
    for (let x = 1; x < canvas.width - 1; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      for (let c = 0; c < 3; c++) {
        const current = tempData[pos + c];
        const top = tempData[pos - canvas.width * 4 + c];
        const bottom = tempData[pos + canvas.width * 4 + c];
        const left = tempData[pos - 4 + c];
        const right = tempData[pos + 4 + c];
        
        // 중앙 픽셀 강화, 주변 픽셀 감소 (샤프닝 효과)
        sharpenData[pos + c] = Math.min(255, Math.max(0, 
          current * 1.5 - (top + bottom + left + right) / 8));
      }
    }
  }
  
  ctx.putImageData(sharpenImageData, 0, 0);
  
  // 3. 색감 조정
  setMessage(language === 'KR' ? '인물 모드 적용 중 (3/3) - 색감 조정...' : 'Applying Portrait Mode (3/3) - Adjusting colors...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // 컬러 조정
  const colorData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const pixels = colorData.data;
  
  for (let i = 0; i < pixels.length; i += 4) {
    // 따뜻한 톤 강화 (Canon 인물 모드 특성)
    pixels[i] = Math.min(255, pixels[i] * 1.05); // 빨간색 살짝 증가
    pixels[i + 2] = Math.min(255, pixels[i + 2] * 0.95); // 파란색 살짝 감소
    
    // 약간의 콘트라스트 증가
    for (let c = 0; c < 3; c++) {
      const value = pixels[i + c];
      pixels[i + c] = value < 128 ? value * 0.95 : Math.min(255, value * 1.05);
    }
  }
  
  ctx.putImageData(colorData, 0, 0);
  
  // 처리 완료
  setMessage(language === 'KR' ? '인물 모드 적용 완료!' : 'Portrait Mode applied!');
};